package com.arenaproplay.admin.navigation

object Routes {

    const val HOME = "/"
    const val LOGIN = "/login"

    // ── New IA surfaces (Night Arena v2) ─────────────────────────────────────
    /** Аналитика — 3 таба: Привлечение / Поведение / Выручка. */
    const val ANALYTICS = "/analytics"
    /** Модерация — Social: посты + сторис. */
    const val MODERATION = "/moderation"
    /** Входящие — Support + Chat табами, живой бейдж. */
    const val INBOX = "/inbox"
    /** Система — 3 таба: Админы / Аудит-лог / API-статистика. */
    const val SYSTEM = "/system"

    // ── Legacy surfaces (kept — content migrates in R6-R8) ───────────────────
    const val DASHBOARD = "/dashboard"
    const val API_STATS = "/api-stats"
    const val INSIGHTS = "/insights"
    const val BEHAVIOR = "/behavior"

    const val USERS = "/users"
    const val PEOPLE = "/people"

    const val EVENTS = "/events"

    const val CLUBS = "/clubs"
    const val CLUB_DETAILS = "/clubs/{id}"

    const val EVENT_DETAILS = "/events/{id}"

    const val SUBSCRIPTIONS = "/subscriptions"

    const val SOCIAL = "/social"
    const val CHAT = "/chat"

    const val CONTENT_STUDIO = "/content-studio"
    const val SUPPORT = "/support"
    const val APP_LAUNCH = "/app-launch"
    const val NEWS = "/news"

    const val AUDIT_LOG = "/audit-log"
    const val ADMINS = "/admins"

    const val SETTINGS = "/settings"

    const val ACQUISITION = "/acquisition"

    fun clubDetails(id: String) = CLUB_DETAILS.replace("{id}", id)

    fun eventDetails(id: String) = EVENT_DETAILS.replace("{id}", id)

    fun extractId(route: String, pattern: String): String? {
        val patternParts = pattern.split("/")
        val routeParts = route.split("/")
        if (patternParts.size != routeParts.size) return null
        for (i in patternParts.indices) {
            if (patternParts[i].startsWith("{") && patternParts[i].endsWith("}")) {
                return routeParts[i]
            }
        }
        return null
    }
}
